<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-data-table
          :headers="discountItemDataTableHeaders"
          :items="discountItemList"
          :search="searchDiscountItem"
          class="elevation-1"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          item-key="Name"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('quotation_item_new_tool_bar_title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchDiscountItem"
                append-icon="mdi-magnify"
                :label="$t('quotation_item_new_install_search')"
                single-line
                hide-details
                clearable
              ></v-text-field>
              <v-btn
                color="primary"
                class="mb-2 ml-8"
                :disabled="isAllTextFieldDisabled"
                @click="isShowEditDiscountItemDialog = true"
              >
                {{ $t('quotation_item_new_install_new_item_btn') }}
              </v-btn>
              <v-dialog
                v-model="isShowEditDiscountItemDialog"
                v-if="isShowEditDiscountItemDialog"
                persistent
              >
                <v-card>
                  <v-card-title>
                    <span class="text-h5">折扣</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <ValidationObserver ref="dialogDiscountItem">
                        <v-row>
                          <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                            <v-checkbox
                              v-model="editedDiscountItem.IsRepeat"
                              :label="$t('discount_item_repeat')"
                              :disabled="isAllTextFieldDisabled"
                            >
                            </v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                            <ValidationProvider
                              :name="$t('discount_item_repeat_warranty_period')"
                              rules="required|min_value:1"
                              v-slot="{ errors }"
                              v-if="editedDiscountItem.IsRepeat"
                            >
                              <v-text-field
                                v-model="editedDiscountItem.RepeatWarrantyPeriod"
                                :label="$t('discount_item_repeat_warranty_period')"
                                :error-messages="errors[0]"
                                :disabled="isAllTextFieldDisabled"
                                @keyup.enter="focusNextInput"
                              >
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                            xl="3"
                            v-if="editedDiscountItemIndex !== -1"
                          >
                            <v-text-field
                              v-model="editedDiscountItem.DiscountId"
                              label="折扣專屬ID"
                              disabled
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-autocomplete
                              v-model="editedDiscountItem.WaitForDiscountIds"
                              :items="waitForDiscountOptions"
                              item-text="DiscountId"
                              item-value="DiscountId"
                              label="等待優惠結束"
                              :disabled="isAllTextFieldDisabled"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_data')"
                              clearable
                              multiple
                              chips
                              small-chips
                              deletable-chips
                              @change="onWaitForDiscountIdsChange"
                            >
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.DiscountId }}</v-list-item-title>
                                  <v-list-item-subtitle
                                    >{{ item.MonthItemNumber }} -
                                    {{ item.MonthItemName }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <item-for-install-month-autocomplete
                              :monthItemList="discountMonthItemList"
                              :editedItemIndex="editedDiscountItemIndex"
                              :itemName="'quotation_item_number'"
                              @setEditedItem="setEditedDiscountItem"
                              v-if="
                                editedDiscountItemIndex === -1 &&
                                  !editedDiscountItem.MonthItemNumber
                              "
                              refName="itemAutocomplete"
                              @keyupEnter="focusNextInput"
                            />
                            <v-text-field
                              v-model="editedDiscountItem.MonthItemNumber"
                              readonly
                              @click:clear="resetDiscountItem"
                              :clearable="editedDiscountItemIndex === -1"
                              :label="$t('quotation_item_number')"
                              v-else
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_name')"
                              rules="required"
                              v-slot="{ errors }"
                              v-if="editedDiscountItem.MonthItemNumber"
                            >
                              <v-text-field
                                v-model="editedDiscountItem.MonthItemName"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_name') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                            <v-autocomplete
                              v-model="editedDiscountItem.DiscountType"
                              :items="allDiscountType"
                              item-text="Name"
                              item-value="Type"
                              :label="$t('discount_item_type')"
                              :disabled="isAllTextFieldDisabled"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_data')"
                              @keyup.enter="setDiscountTypeAutocomplete"
                              ref="discountTypeAutocomplete"
                              @change="setAllDiscount"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" xl="3" lg="3"
                            ><v-autocomplete
                              v-model="editedDiscountItem.UseDiscountType"
                              :items="allDiscountItemType"
                              item-text="Name"
                              item-value="Type"
                              :label="$t('discount_item_use_type')"
                              :disabled="isAllTextFieldDisabled || isLock"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_data')"
                              @keyup.enter="setUseDiscountTypeAutocomplete"
                              ref="useDiscountTypeAutocomplete"
                              @change="setUseDiscountType"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                            <v-text-field
                              v-model="editedDiscountItem.GiveWarrantyPeriod"
                              :label="$t('discount_item_give_warranty_period')"
                              v-if="editedDiscountItem.DiscountType === 1"
                              :disabled="isAllTextFieldDisabled"
                              @keyup.enter="focusNextInput"
                            ></v-text-field>
                            <v-text-field
                              v-model="editedDiscountItem.GivePrepayment"
                              :label="$t('discount_item_prepayment')"
                              v-if="editedDiscountItem.DiscountType === 4"
                              :disabled="isAllTextFieldDisabled"
                              @keyup.enter="focusNextInput"
                            ></v-text-field>
                            <v-text-field
                              v-model="editedDiscountItem.GiveMoney"
                              :label="$t('discount_item_give_money')"
                              v-if="editedDiscountItem.DiscountType === 2"
                              :disabled="isAllTextFieldDisabled"
                              @keyup.enter="focusNextInput"
                            ></v-text-field>
                            <v-text-field
                              v-model="editedDiscountItem.GivePercent"
                              :label="$t('discount_item_give_percent')"
                              v-if="editedDiscountItem.DiscountType === 3"
                              :disabled="isAllTextFieldDisabled"
                              @keyup.enter="focusNextInput"
                            ></v-text-field>
                            <v-text-field
                              v-model="editedDiscountItem.GiveDay"
                              v-if="editedDiscountItem.DiscountType === 5"
                              @keyup.enter="focusNextInput"
                              label="折扣天數"
                              :disabled="isAllTextFieldDisabled"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                            <v-autocomplete
                              v-model="editedDiscountItem.Months"
                              :items="allMonth"
                              :label="$t('discount_item_use_month')"
                              chips
                              multiple
                              small-chips
                              :disabled="isAllTextFieldDisabled"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_data')"
                              v-if="editedDiscountItem.UseDiscountType === 2"
                            ></v-autocomplete>
                            <v-autocomplete
                              v-model="editedDiscountItem.UseWarrantyPeriods"
                              :items="allWarrantyPeriod"
                              :label="$t('discount_item_use_warranty_period')"
                              chips
                              multiple
                              small-chips
                              :disabled="isAllTextFieldDisabled"
                              :loading-text="$t('common_get_data')"
                              :no-data-text="$t('common_no_data')"
                              v-if="editedDiscountItem.UseDiscountType === 1"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-textarea
                            outlined
                            :label="$t('quotation_item_remark')"
                            v-model="editedDiscountItem.Remark"
                            :disabled="isAllTextFieldDisabled"
                          ></v-textarea>
                        </v-row>
                      </ValidationObserver>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeEditedDiscountItem">
                      {{ $t('common_cancel') }}
                    </v-btn>
                    <v-btn
                      color="green darken-1"
                      :disabled="
                        discountMonthItemList.length === 0 && editedDiscountItemIndex === -1
                      "
                      text
                      @click="saveEditedDiscountItem"
                    >
                      {{ $t('common_save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <delete-dialog
                :isAllTextFieldDisable="false"
                :isLoadingSaveBtn="false"
                :isShowDeleteDialog="isShowDeleteDiscountItemDialog"
                :deleteMessage="'quotation_item_delete_item_dialog_title'"
                @closeDelete="closeDeleteDiscountItem"
                @confirmDelete="confirmDeleteDiscountItem"
              />
              <error-dialog ref="errorDialog" />
            </v-toolbar>
          </template>
          <template v-slot:[`item.Edit`]="{ item }">
            <v-btn
              icon
              @click="isShowEditDiscountItemDialogBtn(item)"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="isShowDeleteDiscountItemDialogBtn(item)"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.Move`]="{ item, index }">
            <v-btn
              icon
              @click="upDiscountItem(item)"
              v-if="index !== 0"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon>
                mdi-arrow-up-drop-circle-outline
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="downDiscountItem(item)"
              v-if="index !== discountItemList.length - 1"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon>
                mdi-arrow-down-drop-circle-outline
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.UseDiscountType`]="{ item }">
            {{ turnUseDiscountType(item.UseDiscountType) }}
          </template>
          <template v-slot:[`item.DiscountType`]="{ item }">
            {{ turnDiscountType(item.DiscountType) }}
          </template>
          <template v-slot:[`item.WaitForDiscountIds`]="{ item }">
            <v-chip v-for="id in item.WaitForDiscountIds" :key="id" small class="ma-1">
              {{ id }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DeleteDialog from '@/components/DeleteDialog.vue'
import ErrorDialog from '@/components/ErrorDialog.vue'
import ItemForInstallMonthAutocomplete from '@/components/ItemForInstallMonthAutocomplete.vue'
import { DiscountType } from '@/js/DiscountType'
import { UseDiscountType } from '@/js/UseDiscountType'
import { HttpDiscount } from '@/js/http-Manager'

export default {
  components: {
    DeleteDialog,
    ErrorDialog,
    ItemForInstallMonthAutocomplete
  },
  name: 'NewDiscountSetting',

  data: () => ({
    allDiscountType: [],
    allDiscountItemType: [],
    searchDiscountItem: '',
    isShowEditDiscountItemDialog: false,
    isShowDeleteDiscountItemDialog: false,
    editedDiscountItem: {
      DiscountId: '',
      WaitForDiscountIds: [],
      DiscountType: 1,
      MonthId: '',
      MonthNumber: '',
      MonthWarrantyPeriod: 0,
      MonthItemId: '',
      MonthItemName: '',
      MonthItemNumber: '',
      IsRepeat: false,
      RepeatWarrantyPeriod: 0,
      GivePrepayment: 0,
      GiveWarrantyPeriod: 0,
      GiveMoney: 0,
      GivePercent: 0,
      GiveDay: 0,
      UseDiscountType: 1,
      UseWarrantyPeriods: [],
      Remark: '',
      IsUse: false,
      Month: 0,
      Months: []
    },
    defaultDiscountItem: {
      DiscountId: '',
      WaitForDiscountIds: [],
      DiscountType: 1,
      MonthId: '',
      MonthNumber: '',
      MonthWarrantyPeriod: 0,
      MonthItemId: '',
      MonthItemName: '',
      MonthItemNumber: '',
      IsRepeat: false,
      RepeatWarrantyPeriod: 0,
      GivePrepayment: 0,
      GiveWarrantyPeriod: 0,
      GiveMoney: 0,
      GivePercent: 0,
      GiveDay: 0,
      UseDiscountType: 1,
      UseWarrantyPeriods: [],
      Remark: '',
      IsUse: false,
      Month: 0,
      Months: []
    },
    editedDiscountItemIndex: -1,
    regexPrice: /^[0-9]+$/,
    regexQuantity: /^[0-9]+$/,
    isLock: false,
    discountMonthItemIdList: [],
    errorMessage: ''
  }),
  async mounted () {
    await this.getAllDiscountType()
    await this.getAllDiscountItemType()
  },
  watch: {},
  computed: {
    discountItemDataTableHeaders () {
      return [
        { text: 'ID', value: 'DiscountId' },
        { text: this.$t('quotation_item_number'), value: 'MonthItemNumber' },
        { text: this.$t('quotation_item_name'), value: 'MonthItemName' },
        { text: this.$t('discount_item_repeat'), value: 'IsRepeat' },
        {
          text: this.$t('discount_item_repeat_warranty_period'),
          value: 'RepeatWarrantyPeriod'
        },
        { text: this.$t('discount_item_type'), value: 'DiscountType' },
        { text: this.$t('discount_item_prepayment'), value: 'GivePrepayment' },
        { text: this.$t('discount_item_give_warranty_period'), value: 'GiveWarrantyPeriod' },
        { text: '贈送天數', value: 'GiveDay' },
        { text: this.$t('discount_item_give_money'), value: 'GiveMoney' },
        { text: this.$t('discount_item_give_percent'), value: 'GivePercent' },
        { text: this.$t('discount_item_use_type'), value: 'UseDiscountType' },
        { text: this.$t('discount_item_use_warranty_period'), value: 'UseWarrantyPeriods' },
        { text: this.$t('discount_item_use_month'), value: 'Months' },
        { text: this.$t('quotation_item_remark'), value: 'Remark' },
        { text: '等待優惠結束', value: 'WaitForDiscountIds' },
        { text: this.$t('common_edit'), value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    },
    discountMonthItemList () {
      let array = []
      this.monthItemList.forEach((element) => {
        if (!element.Number && element.MonthBomItems && element.MonthBomItems.length > 0) {
          element.MonthBomItems.forEach((ele) => {
            array.push(ele)
          })
        } else {
          if (!element.MonthNumber) {
            array.push(element)
          }
        }
      })
      return array
    },
    allMonth () {
      let array = []
      for (let index = 1; index < 13; index++) {
        array.push(index)
      }
      return array
    },
    waitForDiscountOptions () {
      // 先過濾掉 IsRepeat 為 true 的項目，並排除自己
      let filtered = this.discountItemList.filter(
        (x) => !x.IsRepeat && x.DiscountId !== this.editedDiscountItem.DiscountId
      )

      // 如果已選擇項目，只顯示相同 MonthItemNumber 的項目
      let selectedIds = this.editedDiscountItem.WaitForDiscountIds || []
      if (selectedIds.length > 0) {
        // 找到第一個已選項目的 MonthItemNumber
        let selectedItem = filtered.find((x) => x.DiscountId === selectedIds[0])
        if (selectedItem) {
          return filtered.filter((x) => x.MonthItemNumber === selectedItem.MonthItemNumber)
        }
      }
      return filtered
    },
    allWarrantyPeriod () {
      let array = []
      if (this.editedDiscountItem.IsRepeat) {
        let month =
          this.editedDiscountItem.RepeatWarrantyPeriod * 1 +
          this.editedDiscountItem.GiveWarrantyPeriod * 1
        for (let index = 1; index <= month; index++) {
          array.push(index)
        }
        return array
      } else if (this.editedDiscountItem.DiscountType === 4) {
        if (this.monthItemList && this.monthItemList.length > 0) {
          let month = this.monthItemList[0].RentWarrantyPeriod * 1
          for (let index = 1; index <= month; index++) {
            array.push(index)
          }
        }

        return array
      } else {
        if (this.monthItemList && this.monthItemList.length > 0) {
          let month =
            this.monthItemList[0].RentWarrantyPeriod * 1 +
            this.editedDiscountItem.GiveWarrantyPeriod * 1
          for (let index = 1; index <= month; index++) {
            array.push(index)
          }
        }
        return array
      }
    }
  },
  methods: {
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    resetDiscountItem () {
      this.editedDiscountItem.MonthItemId = ''
      this.editedDiscountItem.MonthItemNumber = ''
      this.editedDiscountItem.MonthItemName = ''
      this.editedDiscountItem.MonthWarrantyPeriod = 0
      this.editedDiscountItem = JSON.parse(JSON.stringify(this.editedDiscountItem))
    },
    setEditedDiscountItem (val) {
      this.editedDiscountItem.MonthItemId = val.Id
      this.editedDiscountItem.MonthItemNumber = val.Number
      this.editedDiscountItem.MonthItemName = val.Name
      this.editedDiscountItem.MonthWarrantyPeriod = val.RentWarrantyPeriod
      this.editedDiscountItem = JSON.parse(JSON.stringify(this.editedDiscountItem))
    },
    onWaitForDiscountIdsChange (selectedIds) {
      // 當選擇第一個項目時，自動設置品項
      if (selectedIds && selectedIds.length > 0) {
        let selectedDiscountItem = this.discountItemList.find(
          (x) => x.DiscountId === selectedIds[0]
        )
        if (selectedDiscountItem) {
          // 從 discountMonthItemList 找到對應的品項
          let monthItem = this.discountMonthItemList.find(
            (x) => x.Number === selectedDiscountItem.MonthItemNumber
          )
          if (monthItem) {
            this.setEditedDiscountItem(monthItem)
          }
        }
      } else {
        this.editedDiscountItem = JSON.parse(JSON.stringify(this.defaultDiscountItem))
      }
    },
    isShowEditDiscountItemDialogBtn (item) {
      this.editedDiscountItemIndex = this.discountItemList.indexOf(item)
      this.editedDiscountItem = JSON.parse(JSON.stringify(item))
      this.isShowEditDiscountItemDialog = true
    },
    closeEditedDiscountItem () {
      this.isShowEditDiscountItemDialog = false
      this.editedDiscountItem = JSON.parse(JSON.stringify(this.defaultDiscountItem))
      this.editedDiscountItemIndex = -1
    },
    async saveEditedDiscountItem () {
      this.checkWarrantyPeriodQuantity()
      if (this.errorMessage) {
        this.$refs.errorDialog.openDialog(this.errorMessage)
        this.errorMessage = ''
        return
      }
      const isValid = await this.$refs.dialogDiscountItem.validate()
      if (isValid) {
        this.$emit('setDiscountItemIndex', this.editedDiscountItemIndex)
        this.$emit('setDiscountItem', this.editedDiscountItem)
        this.closeEditedDiscountItem()
      }
    },
    checkWarrantyPeriodQuantity () {
      if (this.editedDiscountItem.DiscountType === 1) {
        if (this.editedDiscountItem.UseDiscountType === 1) {
          if (
            this.editedDiscountItem.GiveWarrantyPeriod * 1 !==
            this.editedDiscountItem.UseWarrantyPeriods.length
          ) {
            this.errorMessage = this.$t('discount_error_give_warranty_period_mismatch')
          }
        } else {
          if (
            this.editedDiscountItem.GiveWarrantyPeriod * 1 !==
            this.editedDiscountItem.Months.length
          ) {
            this.errorMessage = this.$t('discount_error_give_month_mismatch')
          }
        }
      } else if (this.editedDiscountItem.DiscountType === 4) {
        if (this.editedDiscountItem.UseDiscountType === 1) {
          if (
            this.editedDiscountItem.GivePrepayment * 1 !==
            this.editedDiscountItem.UseWarrantyPeriods.length
          ) {
            this.errorMessage = this.$t('discount_error_prepayment_warranty_period_mismatch')
          }
        } else {
          if (
            this.editedDiscountItem.GivePrepayment * 1 !==
            this.editedDiscountItem.Months.length
          ) {
            this.errorMessage = this.$t('discount_error_prepayment_month_mismatch')
          }
        }
      }
    },
    confirmDeleteDiscountItem () {
      this.$emit('deleteDiscountItem', this.editedDiscountItemIndex)
      this.closeDeleteDiscountItem()
    },
    isShowDeleteDiscountItemDialogBtn (item) {
      this.editedDiscountItemIndex = this.discountItemList.indexOf(item)
      this.isShowDeleteDiscountItemDialog = true
    },
    closeDeleteDiscountItem () {
      this.editedDiscountItemIndex = -1
      this.isShowDeleteDiscountItemDialog = false
    },
    downDiscountItem (item) {
      let temp = JSON.parse(JSON.stringify(this.discountItemList))
      let currentIndex = temp.findIndex(
        (x) =>
          x.MonthItemId === item.MonthItemId &&
          x.DiscountType === item.DiscountType &&
          x.UseDiscountType === item.UseDiscountType
      )
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllDiscount', temp)
    },
    upDiscountItem (item) {
      let temp = JSON.parse(JSON.stringify(this.discountItemList))
      let currentIndex = temp.findIndex(
        (x) =>
          x.MonthItemId === item.MonthItemId &&
          x.DiscountType === item.DiscountType &&
          x.UseDiscountType === item.UseDiscountType
      )
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllDiscount', temp)
    },
    setDiscountTypeAutocomplete (event) {
      this.$refs.discountTypeAutocomplete.isMenuActive = false
      this.$refs.discountTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setUseDiscountTypeAutocomplete (event) {
      this.$refs.useDiscountTypeAutocomplete.isMenuActive = false
      this.$refs.useDiscountTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setAllDiscount () {
      this.editedDiscountItem.GiveMoney = 0
      this.editedDiscountItem.GivePercent = 0
      this.editedDiscountItem.GiveWarrantyPeriod = 0
      this.editedDiscountItem.GiveDay = 0
      this.editedDiscountItem.GivePrepayment = 0
      this.setUseDiscountType()
      if (this.editedDiscountItem.DiscountType === 4) {
        this.editedDiscountItem.UseDiscountType = 1
        this.isLock = true
      } else {
        this.isLock = false
      }
    },
    setUseDiscountType () {
      this.editedDiscountItem.Months = []
      this.editedDiscountItem.UseWarrantyPeriods = []
    },
    turnUseDiscountType (val) {
      return UseDiscountType.UseDiscountTypeName(val)
    },
    turnDiscountType (val) {
      return DiscountType.DiscountTypeName(val)
    },
    async getAllDiscountType () {
      let response = await HttpDiscount.GetDiscountType()
      this.allDiscountType = response.status === 200 ? response.data.Data : []
    },
    async getAllDiscountItemType () {
      let response = await HttpDiscount.GetDiscountItemType()
      this.allDiscountItemType = response.status === 200 ? response.data.Data : []
    }
  },
  props: {
    isAllTextFieldDisabled: {
      type: Boolean
    },
    monthItemList: {
      type: Array
    },
    discountItemList: {
      type: Array
    }
  }
}
</script>
